import { render, staticRenderFns } from "./UserConfigView.vue?vue&type=template&id=4627b42c&"
import script from "./UserConfigView.vue?vue&type=script&lang=js&"
export * from "./UserConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports